module.exports = __webpack_public_path__ + "static/media/192-philippines.bfca65b7.svg";